// RITA-1498 (Nutzungserfassung Phase 1b) — Konfiguration (GET /usage/config) und App-Version.
// Fail-closed wie der Server: jede Störung bedeutet "Erfassung aus". Die App-Version ist der
// GIT_COMMIT aus /static/env.json (Dockerfile schreibt ihn beim Build; lokal "not-set-in-dev").
import type { IUsageConfig } from 'global-intern-types';

export const USAGE_CONFIG_ENDPOINT = '/usage/config';
export const APP_VERSION_ENDPOINT = '/static/env.json';

export const DISABLED_CONFIG: IUsageConfig = { enabled: false, sampleRate: 0, heatmap: false };

export type JsonFetchLike = (
  input: string,
  init?: RequestInit,
) => Promise<{ status: number; ok: boolean; json: () => Promise<unknown> }>;

const isConfigShape = (value: unknown): value is { enabled: boolean; sampleRate?: unknown; heatmap?: unknown } =>
  typeof value === 'object' && value !== null && typeof (value as { enabled?: unknown }).enabled === 'boolean';

export const fetchUsageConfig = async ({
  fetchImpl,
  getToken,
}: {
  fetchImpl: JsonFetchLike;
  getToken: () => string | null;
}): Promise<IUsageConfig> => {
  const token = getToken();
  if (!token) return DISABLED_CONFIG;
  try {
    const response = await fetchImpl(USAGE_CONFIG_ENDPOINT, { headers: { authorization: `Bearer ${token}` } });
    if (!response.ok) return DISABLED_CONFIG;
    const body = await response.json();
    if (!isConfigShape(body)) return DISABLED_CONFIG;
    const sampleRate = Number(body.sampleRate);
    return {
      enabled: body.enabled,
      sampleRate: Number.isFinite(sampleRate) ? Math.min(1, Math.max(0, sampleRate)) : 1,
      heatmap: body.heatmap === true,
    };
  } catch {
    return DISABLED_CONFIG;
  }
};

export const fetchAppVersion = async ({ fetchImpl }: { fetchImpl: JsonFetchLike }): Promise<string> => {
  try {
    const response = await fetchImpl(APP_VERSION_ENDPOINT, { cache: 'no-store' });
    if (!response.ok) return '';
    const body = (await response.json()) as { GIT_COMMIT?: unknown };
    return typeof body?.GIT_COMMIT === 'string' ? body.GIT_COMMIT.trim() : '';
  } catch {
    return '';
  }
};
